import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Select from "react-select";
import '../styles/StageList.css';
import { useNavigate } from "react-router-dom";

interface StageFormProps {
    initialData?: {
        stage_name: string;
        description?: string | null;   // ✅ FIX
        is_active: boolean;
    };
    onSubmit: (data: {
        stage_name: string;
        description?: string;
        is_active: boolean;
    }) => Promise<void>;
    submitLabel?: string;
}


const StageForm: React.FC<StageFormProps> = ({
    initialData,
    onSubmit,
    submitLabel = "Save",
}) => {
    const [formData, setFormData] = useState({
        stage_name: "",
        description: "",
        is_active: "Active",
    });
    const navigate = useNavigate();

    const [errors, setErrors] = useState<Record<string, string>>({});
    const [submitting, setSubmitting] = useState(false);
    const statusOptions = [
        { value: "Active", label: "Active" },
        { value: "Inactive", label: "Inactive" },
    ];

    /* PREFILL (EDIT MODE) */
    useEffect(() => {
        if (initialData) {
            setFormData({
                stage_name: initialData.stage_name,
                description: initialData.description || "", // ✅ null-safe
                is_active: initialData.is_active ? "Active" : "Inactive",
            });
        }
    }, [initialData]);

    const validate = () => {
        const e: Record<string, string> = {};
        if (!formData.stage_name.trim()) {
            e.stage_name = "Stage name is required";
        }
        setErrors(e);
        return Object.keys(e).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        setSubmitting(true);
        try {
            await onSubmit({
                stage_name: formData.stage_name,
                description: formData.description,
                is_active: formData.is_active === "Active",
            });
        } catch (err) {
            toast.error("Failed to save stage");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="bg-gray">
            <div className="container pt-4 pb-4">
                <div className="card p-4">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="form-floating">
                                <input
                                    className={`form-control ${errors.stage_name ? "is-invalid" : ""}`}
                                    placeholder="Stage Name"
                                    value={formData.stage_name}
                                    onChange={(e) =>
                                        setFormData({ ...formData, stage_name: e.target.value })
                                    }
                                />
                                <label>Stage Name *</label>
                                {errors.stage_name && (
                                    <div className="invalid-feedback">{errors.stage_name}</div>
                                )}
                            </div>
                        </div>

                        <div className="col-md-6 stage-list">
                            {/* <label className="form-label fw-semibold">Status *</label> */}

                            <Select
                                options={statusOptions}
                                value={
                                    statusOptions.find(
                                        opt => opt.value === formData.is_active
                                    ) || null
                                }
                                isSearchable={false}
                                onChange={(selected) =>
                                    setFormData(prev => ({
                                        ...prev,
                                        is_active: selected?.value || "Active",
                                    }))
                                }
                                placeholder="Select Status"
                                classNamePrefix="react-select"
                            />
                        </div>
                       


                        <div className="col-md-12">
                            <div className="form-floating">
                                <textarea
                                    className="form-control"
                                    style={{ height: "100px" }}
                                    placeholder="Description"
                                    value={formData.description}
                                    onChange={(e) =>
                                        setFormData({ ...formData, description: e.target.value })
                                    }
                                />
                                <label>Description</label>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-end mt-4 pt-4 btn-footer gap-2">
                         <button className="btn btn-outline-secondary" onClick={() => navigate("/stage")}>
                            Cancel
                        </button>
                        <button
                            className="btn btn-primary"
                            onClick={handleSubmit}
                            disabled={submitting}
                        >
                            {submitting ? "Saving..." : submitLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StageForm;
